<template>
  <div :class="['card-profile-images', { page }]">
    <template v-if="cardFront || cardBack">
      <div class="image-container">
        <card-image
          class="front-image"
          :image-url="cardFront"
          :alt="card.label"
          @click.stop.prevent="fullScreenImage = cardFront"
        />

        <card-image
          v-if="hasBackImage"
          class="back-image"
          :image-url="cardBack"
          :alt="card.label"
          @click.stop.prevent="fullScreenImage = cardBack"
        />
      </div>

      <fullscreen-image
        :show="!!fullScreenImage"
        :image="fullScreenImage"
        :label="card.label"
        :has-back-image="hasBackImage"
        @hide="fullScreenImage = ''"
        @flip="flipFullscreenImage"
      />
    </template>

    <div
      v-else-if="card.collectionCardId"
      class="image-placeholder"
      @click.stop.prevent="edit"
    >
      <icon class="icon" name="cloud_upload" />
      <div>Upload an image</div>
    </div>
  </div>
</template>

<script>
import CardImage from './CardImage';
import FullscreenImage from './FullscreenImage';
import Icon from './Icon';

export default {
  components: {
    CardImage,
    FullscreenImage,
    Icon,
  },

  props: {
    card: Object,
    page: Boolean,
  },

  data() {
    return {
      fullScreenImage: '',
      showBackImage: false,
    };
  },

  computed: {
    hasBackImage() {
      return Boolean(this.card.imageBack);
    },

    cardFront() {
      if (this.showBackImage) return this.card.imageBack;

      return this.card.imageCustom || this.card.image;
    },

    cardBack() {
      if (this.showBackImage) return this.card.imageCustom || this.card.image;

      return this.card.imageBack;
    },
  },

  methods: {
    edit() {
      this.$bus.$emit('collection-edit-card', {
        id: this.card.collectionCardId,
        investment: false,
        collectionId: this.card.collectionId,
      });
    },

    flipFullscreenImage() {
      if (this.fullScreenImage === this.cardFront) {
        this.fullScreenImage = this.cardBack;
      } else if (this.fullScreenImage === this.cardBack) {
        this.fullScreenImage = this.cardFront;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-profile-images {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-highlight);
  padding: $gp;
  border-radius: $border-radius;

  &.page {
    .card-image {
      @media($large-down) {
        --card-image-width: 120px;
        min-width: 120px;
      }
    }
  }
}

.card-image {
  --card-image-width: 200px;
  min-width: 200px;

  @media($medium-down) {
    --card-image-width: 160px;
    min-width: 160px;
  }
}

.image-container {
  display: flex;
}

.image-placeholder {
  border: 1px solid var(--theme-input-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: $gp * .5 $gp;
  height: 300px;
  cursor: pointer;

  .icon {
    font-size: 40px;
    color: $color-gray-5;
  }
}
</style>
